import * as React from 'react';
import NoDataFound from "../ProductListing/NoDataFound";

export function ProductListingNotFound() {
    return (
        <>
            <NoDataFound/>
        </>
    );
}
